module.exports = __webpack_public_path__ + "static/media/e.cosentino.ed413b9c.svg";